<template>
  <div>
    <v-dialog 
      :value="dialogPlanos" 
      @input="$emit('update:dialogPlanos', $event)" 
      persistent 
      scrollable 
      fullscreen
    >
      <v-card class="d-flex flex-column" style="height: 100vh;">
        <v-toolbar
          flat
          dense
          color="blue darken-2"
          dark
          height="48"
        >
          <v-toolbar-title class="text-subtitle-1 font-weight-medium">
            Ubicación: {{ planoYposicion ? planoYposicion.nombre : 'Cargando...' }}
          </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon  @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
    

        <v-card-text class="flex-grow-1 pa-0">
          <div v-if="!planoYposicion || !planoYposicion.id" class="pa-6 grey--text text--darken-1">
            Selecciona un armario con plano asociado.
          </div>
         <SoloPlanos 
            v-if="dialogPlanos && planoYposicion && planoYposicion.id" 
            :key="planoYposicion.id" 
            :nodo="nodo" 
            :selectedPlano="planoYposicion"
            @select="select"
            @ir-a-subplano="$emit('ir-a-subplano', $event)"
            @add-adjunto="$emit('add-adjunto', $event)"
            @ver-en-arbol="$emit('ver-en-arbol', $event)"
            @ver-en-plano="$emit('ver-en-plano', $event)"
            style="height: 100%; width: 100%;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SoloPlanos from '../SoloPlanos.vue';

export default {
  components: { SoloPlanos },
  props: {
    planoYposicion: Object,
    nodo: Object,
    dialogPlanos: Boolean,
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    select(nodo) {
      this.$emit('select', nodo);
    }
  },
};
</script>